<template>
  <b-container>
    <b-card
      v-if="renderPage"
      title="Link de Recorrência"
    >
      <b-card
        v-if="showInputPayment"
        class="card-form"
      >
        <b-row class="mb-2 column-change">
          <b-col>
            <validation-observer ref="simpleRules">
              <b-form @submit.prevent>
                <b-card title="Dados do cartão">
                  <b-row>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Nome do titular do cartão"
                        label-for="v-cardName"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Nome do titular do cartão"
                          rules="required"
                        >
                          <b-form-input
                            id="v-cardName"
                            v-model="req.credit_card.card_holder_name"
                            type="text"
                            placeholder="Nome do titular do cartão"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Número cartão"
                        label-for="v-credit-card"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Número cartão"
                          rules="required|credit-card"
                        >
                          <b-input-group
                            class="input-group-merge"
                            :class="errors.length > 0 ? 'is-invalid':null"
                          >
                            <b-form-input
                              id="v-credit-card"
                              v-model="req.credit_card.card_number"
                              v-mask="['#### #### #### ####', '#### ###### #####']"
                              :onkeyup="checkCreditCard()"
                              type="tel"
                              placeholder="Informe o número do cartão"
                              :state="errors.length > 0 ? false : null"
                            />
                            <b-input-group-append
                              v-if="showFlagCard"
                              is-text
                            >
                              <b-img
                                :style="`width: ${card.size}em`"
                                :src="cardBrandIcon"
                              />
                            </b-input-group-append>
                          </b-input-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="CVV"
                        label-for="v-card-cvv"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="CVV"
                          rules="required"
                        >
                          <b-form-input
                            id="name"
                            v-model="req.credit_card.cvv"
                            v-mask="['###', '####']"
                            placeholder="CVV"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="6"
                      sm="6"
                      md="6"
                      lg="3"
                    >
                      <b-form-group
                        label="Expiração"
                        label-for="v-month"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Mês"
                          rules="required"
                        >
                          <b-form-select
                            id="v-month"
                            v-model="month"
                            :options="optionsMonths"
                            :state="errors.length > 0 ? false : null"
                          >
                            <template v-slot:first>
                              <b-form-select-option
                                :value="null"
                                disabled
                              >
                                Mês
                              </b-form-select-option>
                            </template>
                          </b-form-select>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="6"
                      sm="6"
                      md="6"
                      lg="3"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Ano"
                        :rules="month ? `required|date:${month}`: 'required'"
                      >
                        <b-form-select
                          id="v-year"
                          v-model="year"
                          class="year"
                          :options="optionsYears"
                          :state="errors.length > 0 ? false : null"
                        >
                          <template v-slot:first>
                            <b-form-select-option
                              disabled
                              :value="null"
                            >
                              Ano
                            </b-form-select-option>
                          </template>
                        </b-form-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-card>
                <b-card title="Dados do Portador do Cartão">
                  <b-row>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Nome Completo"
                        label-for="v-first-name"
                      >
                        <validation-provider
                          #default="{ errors }"
                          rules="required"
                          name="Nome Completo"
                        >
                          <b-form-input
                            id="v-first-name"
                            v-model="req.billing.name"
                            placeholder="Digite o nome do cliente"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                    >
                      <b-form-group
                        label="Documento"
                        label-for="v-document"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Documento"
                          :rules="`required|${isForeigner ? '' : 'document'}`"
                        >
                          <b-form-input
                            id="v-document"
                            v-model="req.billing.tax_id"
                            v-mask="isForeigner ? ['#################'] : [
                              '###.###.###-##',
                              '##.###.###/####-##',
                              '##.###.###',
                            ]"
                            type="text"
                            placeholder="Informe o Documento"
                            :state="errors.length > 0 ? false : null"
                            style="width: 100%"
                          />

                          <small class="text-danger">{{
                            errors[0]
                          }}</small></validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="E-mail"
                        label-for="v-email"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="E-Mail"
                          rules="required|email"
                        >
                          <b-form-input
                            id="v-email"
                            v-model="req.billing.email"
                            type="email"
                            placeholder="Email"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Telefone"
                        label-for="v-mobile"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Telefone"
                          rules="required|phone"
                        >
                          <b-form-input
                            id="v-mobile"
                            v-model="req.billing.phone"
                            v-mask="['(##) #####-####', '(##) ####-####']"
                            placeholder="Informe o telefone"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Data de Nascimento"
                        label-for="v-born"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Data de Nascimento"
                          rules="required|bornDate"
                        >
                          <b-form-input
                            id="v-born"
                            v-model="req.billing.birth_date"
                            placeholder="Data de Nascimento"
                            type="date"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="12">
                      <b-form-group
                        label-for="is-foreinger"
                        label="É estrangeiro?"
                      >
                        <b-form-checkbox
                          id="is-foreinger"
                          v-model="isForeigner"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card>
                <b-card title="Endereço Portador do Cartão">
                  <b-row>
                    <b-col
                      sm="12"
                      lg="3"
                      md="12"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="País"
                        label-for="v-country"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="País"
                          rules="required"
                        >
                          <b-form-select
                            id="v-country"
                            v-model="req.billing.country"
                            :options="options"
                            :state="errors.length > 0 ? false : null"
                            selected="32"
                          >
                            <template v-slot:first>
                              <b-form-select-option value="BR">
                                Brasil
                              </b-form-select-option>
                            </template>
                          </b-form-select>
                          <small class="text-danger">
                            {{ errors[0] }}
                          </small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      lg="3"
                      md="12"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="CEP"
                        label-for="v-cep"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="CEP"
                          :rules="`required|${req.billing.country == 'BR' ? `cep: ${req.billing.state}` : ''}`"
                        >
                          <b-form-input
                            id="v-cep"
                            v-model="req.billing.postal_code"
                            v-mask="req.billing.country === 'BR' ? '#####-###' : '##########'"
                            placeholder="CEP"
                            :state="errors.length > 0 ? false : null"
                            @change="req.billing.country==='BR' ? searchPostalCode() : ''"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      lg="3"
                      md="12"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Estado"
                        label-for="v-state"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Estado"
                          :rules="req.billing.country !== 'BR' ? 'required' : ''"
                        >
                          <b-form-input
                            id="v-state"
                            v-model="req.billing.state"
                            placeholder="Estado"
                            :readonly="req.billing.country === 'BR' ? true : false"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      lg="3"
                      md="12"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Cidade"
                        label-for="v-city"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Cidade"
                          :rules="req.billing.country !== 'BR' ? 'required' : ''"
                        >
                          <b-form-input
                            id="v-city"
                            v-model="req.billing.city"
                            placeholder="Cidade"
                            :readonly="req.billing.country === 'BR' ? true : false"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Endereço"
                        label-for="v-address"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Endereço"
                          :rules="req.billing.country !== 'BR' ? 'required' : ''"
                        >
                          <b-form-input
                            id="v-address"
                            v-model="req.billing.address"
                            placeholder="Endereço"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Bairro"
                        label-for="v-district"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Bairro"
                          :rules="req.billing.country !== 'BR' ? 'required' : ''"
                        >
                          <b-form-input
                            id="v-district"
                            v-model="req.billing.district"
                            placeholder="Bairro"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      md="6"
                      lg="3"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Número"
                        label-for="v-number"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Número"
                          rules="required"
                        >
                          <b-form-input
                            id="v-number"
                            v-model="req.billing.number"
                            type="number"
                            placeholder="Número"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      md="6"
                      lg="3"
                    >
                      <b-form-group
                        label="Complemento"
                        label-for="v-complemento"
                      >
                        <b-input-group class="input-group-merge">
                          <b-form-input
                            id="v-complemento"
                            v-model="req.billing.complement"
                            placeholder="Complemento"
                          />
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card>
              </b-form>
            </validation-observer>
            <div class="container">
              <b-form-checkbox
                id="v-check"
                v-model="samePerson"
                class="option"
              >Comprador e
                portador do cartão são a mesma pessoa?
              </b-form-checkbox>
            </div>
          </b-col>
          <!-- desc card -->
          <b-col
            sm="12"
            md="6"
            lg="4"
            class="py-2"
          >
            <information
              :data="res"
            />
          </b-col>
        </b-row>
      </b-card>

      <div
        v-if="showInputPayment"
        align="center"
      >
        <b-button
          variant="info"
          @click="validationForm()"
        >
          {{ buttonNextPage }}
        </b-button>
      </div>

      <div v-if="!showInputPayment">
        <b-row class="d-flex align-items-center justify-content-center">
          <!--Success Icon-->
          <icon
            :type="res.link.status.icon"
            class="icon"
          />
          <div
            class="text-center"
          >
            <h3> {{ res.link.status.text }} </h3>
          </div></b-row></div>
      <div v-if="!showInputPayment">
        <b-col
          md="12"
          xl="12"
        >
          <Receipt
            type="recurrence"
            :receipt-data="res"
          />

        </b-col>
      </div>
    </b-card>
  </b-container>
</template>
<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BFormCheckbox,
  BForm,
  BInputGroup,
  BButton,
  BCard,
  BImg,
  BContainer,
  BInputGroupAppend,
} from 'bootstrap-vue'
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'

import { required } from '@validations'

import Ripple from 'vue-ripple-directive'

import { payLink, getLink } from '@/service/pay/pay'
import { getPostalCode, getUserInfo } from '@/service/others/others'

import Icon from '@/layouts/components/Icon.vue'
import Receipt from '@/layouts/components/Receipt.vue'
import Information from '@/layouts/components/payment-link/Information.vue'

import { callLoading } from '@/service/utilities/utilities'

import { doCardBrand } from '@/service/utilities/payment-link/payment-link'

const countries = require('@/information/countries').default
const months = require('@/information/months').default

export default {
  components: {
    BContainer,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BFormCheckbox,
    BInputGroup,
    BForm,
    BButton,
    BImg,
    BCard,
    Icon,
    Receipt,
    Information,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      res: {
        customer: {},
        product: {},
        payment: {},
        user: {},
        link: { status: {} },
      },
      isForeigner: false,
      samePerson: false,
      showFlagCard: false,
      showInputPayment: true,
      year: null,
      month: null,
      options: countries,
      optionsMonths: months,
      optionsYears: [],
      buttonNextPage: 'Próxima etapa',
      checker: false,
      renderPage: false,
      req: {
        credit_card: {
          card_holder_name: null,
          card_number: null,
          expiration_date: null,
          cvv: null,
        },
        payment: {
          value: null,
          currency: 'BRL',
        },
        billing: {
          name: null,
          phone: null,
          email: null,
          tax_id: null,
          birth_date: null,
          address: null,
          number: null,
          complement: null,
          district: null,
          postal_code: null,
          city: null,
          state: null,
          country: 'BR',
        },
      },
      card: {
        image: null,
        size: null,
      },
      typeStatus: {
        1: {
          code: 1,
          icon: 'success',
          text: 'Pagamento Foi Aprovado',
          status: 'Aprovado',
        },
        3: {
          code: 3,
          icon: 'warning',
          text: 'Pagamento em Revisão',
          status: 'Revisão',
        },
        5: {
          code: 5,
          icon: 'loading',
          text: 'Pagamento em Processamento',
          status: 'Revisão',
        },
        9: {
          code: 9,
          icon: 'success',
          text: 'Recorrência foi Criada',
          status: 'Criada',
        },
        12: {
          code: 12,
          icon: 'danger',
          text: 'Link Expirado',
        },
      },
    }
  },
  computed: {
    cardBrandIcon() {
      return require(`@/assets/images/paymentIcons/${this.card.image}.svg`)
    },

    valueInReal() {
      const formatter = new Intl.NumberFormat('pt-br', {
        style: 'currency',
        currency: 'BRL',
      })
      return formatter.format(this.res.payment.value)
    },
  },
  watch: {
    samePerson(value) {
      this.buttonNextPage = value ? 'Pagar' : 'Próxima Página'
    },
  },
  async mounted() {
    this.renderPage = false
    callLoading(true)
    this.resizeScreen()
    window.addEventListener('resize', this.resizeScreen)
    await this.getData()
    await this.generateJsonYear()
    callLoading(false)
  },
  methods: {
    error(errorText) {
      this.$swal({
        title: errorText,
        icon: 'error',
        timer: 2000,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
    resizeScreen() {
      if (window.innerWidth < 500) {
        this.showFlagCard = false
        return
      }
      this.showFlagCard = this.cardIsPotentiallyValid
    },
    // axios function
    async getData() {
      const { hash } = this.$route.params
      this.hash = hash

      const response = await getLink('recurrence-link', this.hash)
      const { status } = response
      if (status === 200) {
        this.res = response.data
        if (response.data.link.status === 1 || response.data.link.status === 3 || response.data.link.status === 5 || response.data.link.status === 9 || response.data.link.status === 12) {
          this.showInputPayment = false
          this.res.link.status = this.typeStatus[this.res.link.status]
        } else { this.showInputPayment = true }
        this.renderPage = true
      } else {
        // this.$router.push('/error-404')
      }
    },

    async searchPostalCode() {
      const { data } = await getPostalCode(this.req.billing.postal_code)
      const {
        address, city, district, state,
      } = data

      this.req.billing.state = state
      this.req.billing.city = city
      this.req.billing.address = address
      this.req.billing.district = district
    },
    checkCreditCard() {
      if (window.innerWidth < 500) {
        this.showFlagCard = false
        return
      }

      const cardValidate = doCardBrand(this.req.credit_card.card_number)

      if (cardValidate) {
        const { cardImage, isPotentiallyValid } = cardValidate
        this.showFlagCard = !!cardImage
        this.card = cardImage
        this.isPotentiallyValid = isPotentiallyValid
      }
    },
    async payLink() {
      await this.createModal()
      if (!this.checker) return
      callLoading(true, true)
      this.req.shipping = this.req.billing
      this.updateObjectPayment()

      try {
        const response = await payLink('recurrence-link', this.hash, this.req)
        if (response.status === 200) {
          this.$router.push(`/recorrencia/status/${this.hash}`)
        }
        else if (response.data.response_message == 'AUTHORIZATION_ERROR') {
          this.error('Pagamento negado pelo emissor. Entre em contato com o emissor do cartão.')
        } else if (response.data.response_code == 5 || response.data.response_code == 255 || response.data.response_code == 259) {
          this.error('Pagamento negado pelo emissor. Entre em contato com o emissor do cartão.')
        } else if (response.data.response_code == 9) {
          this.error('Data do vencimento do cartão de crédito preenchido incorreto.')
        } else if (response.data.response_code == 11) {
          this.error('Número do cartão de crédito errado ou inexistente.')
        } else if (response.data.response_code == 13) {
          this.error('Número CVV do cartão é inválido.')
        } else {
          this.error('Falha de processamento. Entrar em contato com o suporte SoulPay.')
        }
      } catch {
        this.error('Falha de processamento. Entrar em contato com o suporte SoulPay.')
      } finally {
        callLoading(false)
      }
    },
    // call expiration date validator
    // generate objects to select
    generateJsonYear() {
      const data = new Date()
      for (let i = data.getFullYear(); i < data.getFullYear() + 15; i += 1) {
        this.optionsYears.push({
          value: i,
          text: i,
        })
      }
    },
    // fix req object
    updateObjectPayment() {
      this.req.billing.postal_code = this.req.billing.postal_code.replace('-', '')

      this.req.credit_card.card_number = this.req.credit_card.card_number.replaceAll(' ', '')
      this.req.credit_card.expiration_date = (`${this.month}/${this.year}`)
      this.req.billing.postal_code = this.req.billing.postal_code.replace('-', '')

      this.req.payment.value = +this.res.payment.value
    },
    // send data
    validationForm() {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          if (this.samePerson) {
            this.payLink()
          } else {
            this.updateObjectPayment()
            this.$router.push({
              path: `/link-recorrencia/2/${this.hash}`,
              query: {
                req: this.req,
                product: this.res,
              },
            })
          }
        }
      })
    },
  async getUserInfo() {
    try {
      const data = await getUserInfo()
      const { ip } = data
      this.req.customer = {
        ...this.req.customer,
        ip,
        browser: data.browser,
        platform: data.platform,
        deviceType: data.deviceType,
        screen: data.screen,
        language: data.language,
        userAgent: data.userAgent,
      }
    } catch {
      this.$router.push('/error-404')
    }
  },

    async createModal() {
      await this.$bvModal
        .msgBoxConfirm('Confirmar Pagamento', {
          title: 'Por Favor Confirme',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        }).then(value => {
          this.checker = value
        })
    },
  },
}
</script>
<style lang="scss" scoped>
  @import "@core/scss/vue/pages/page-payment-link.scss";

  .response-title {
    margin-top: 2.1rem;
  }
</style>
